import { configureStore } from '@reduxjs/toolkit'
import { accountReducer } from './basic/account/accountReducer'
import apprenticesReducer from './basic/apprentice/apprenticeReducer'
import { companyReducer } from './basic/company/companyReducer'
import { documentTypeReducer } from './basic/dossier/documentTypeReducer'
import employeesReducer from './basic/employee/employeeReducer'
import { errorReducer } from './basic/error/errorReducer'
import { moduleReducer } from './basic/grades/apprenticeship-module/moduleReducer'
import { gradeSchemaReducer } from './basic/grades/grade-schema/gradeSchemaReducer'
import { groupReducer } from './basic/group/groupReducer'
import { loadingReducer } from './basic/loading/loadingReducer'
import personReducer from './basic/person/personReducer'
import professionReducer from './basic/profession/professionReducer'

import claimReducer from './basic/user/claimSlice'
import userReducer from './basic/user/userSlice'
import { educationReportReducer } from './official-document/education-report/educationReportReducer'
import observationReducer from './official-document/education-report/observation/observationReducer'
import { learningJournalReducer } from './official-document/learning-journal/learningJournalReducer'
import { trialPeriodReportsReducer } from './official-document/trial-period-report/trialPeriodReportReducer'


const store = configureStore({
	reducer: {
		user: userReducer,
		claims: claimReducer,
		loadingCounter: loadingReducer,
		errors: errorReducer,

		// basic
		professions: professionReducer,

		// hrm
		persons: personReducer,
		apprentices: apprenticesReducer,
		employees: employeesReducer,
		companies: companyReducer,
		groups: groupReducer,
		accounts: accountReducer,

		// documents
		trialPeriodReports: trialPeriodReportsReducer,
		educationReports: educationReportReducer,
		observations: observationReducer,

		documentTypes: documentTypeReducer,

		// grades
		apprenticeshipModules: moduleReducer,
		gradeSchemas: gradeSchemaReducer,
		learningJournals: learningJournalReducer
	}
	// middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
})

export type RootState = ReturnType<typeof store.getState>;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store

// TODO FB --> use typesafe-actions lib https://www.npmjs.com/package/typesafe-actions